import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/utils/publish.ts'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/icons/components'
import '@/permission'

// vue-quill-editor富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


//  百度地图
import BaiduMap from 'vue-baidu-map'

// 上传图片裁剪
import VueCropper from 'vue-cropper' 

Vue.use(VueCropper)



Vue.use(BaiduMap, {
  ak: 'Ajt4LAe8hamcYk326Tdnqnz3hWUeV3uG'
})

Vue.use(ElementUI)
Vue.use(VueQuillEditor)

Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
